import HMS from './HMS.webp'
import SMPS from './SMPS.png'
import image from './image.png'

const mywork_data = [
    {
        w_no:1,
        w_name:"Stock Market Prediction System",
        w_img:SMPS,
        w_link:'https://github.com/Anuj-Bhusal/Stock-Market-Prediction-System'
    },
    {
        w_no:2,
        w_name:"Hospital Management System Using Python",
        w_img:HMS,
        w_link:'https://github.com/Anuj-Bhusal/Hospital-management-system'
    },
    {
        w_no:3,
        w_name:"My Portfolio using react js",
        w_img:image,
        w_link:"https://github.com/Anuj-Bhusal/My-Portfolio"
    },
]
 
export default mywork_data;